import useSettingsResearchTypeEditRoute_AddSpecies from "../api/useSettingsResearchTypeEditRoute_AddSpecies";
import useSettingsResearchTypeEditRoute_Delete from "../api/useSettingsResearchTypeEditRoute_Delete";
import useSettingsResearchTypeEditRoute_GetById from "../api/useSettingsResearchTypeEditRoute_GetById";
import useSettingsResearchTypeEditRoute_RemoveSpecies from "../api/useSettingsResearchTypeEditRoute_RemoveSpecies";
import useSettingsResearchTypeEditRoute_Update from "../api/useSettingsResearchTypeEditRoute_Update";
import { useSettingsResearchTypeEditRoute_UpdateShowToClientUser } from "../api/useSettingsResearchTypeEditRoute_UpdateShowToClientUser";
import useSettingsResearchTypeEditRoute_UpdateVisitSummaryTemplate from "../api/useSettingsResearchTypeEditRoute_UpdateVisitSummaryTemplate";

export function useSettingsResearchTypeData(researchTypeId: string) {
    const queryData = useSettingsResearchTypeEditRoute_GetById(researchTypeId);
    const updateMutation = useSettingsResearchTypeEditRoute_Update();
    const deleteMutation = useSettingsResearchTypeEditRoute_Delete();

    const addSpeciesMutation = useSettingsResearchTypeEditRoute_AddSpecies();
    const removeSpeciesMutation = useSettingsResearchTypeEditRoute_RemoveSpecies();
    const updateSpeciesShowToClientUserMutation = useSettingsResearchTypeEditRoute_UpdateShowToClientUser();
    const updateVisitSummaryTemplateMutation = useSettingsResearchTypeEditRoute_UpdateVisitSummaryTemplate();

    return {
        queryData,
        updateMutation,
        deleteMutation,
        addSpeciesMutation,
        removeSpeciesMutation,
        updateSpeciesShowToClientUserMutation,
        updateVisitSummaryTemplateMutation,
    };
}
